import { Table, Tag, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import React, { useMemo } from 'react';

const TicketTable: React.FC = () => {
  const rawData: any[] = [
    {
      ticket_no: '7843022793852',
      date: '2025-02-03',
      amount: '69515.00',
      type: 'trabill',
    },
    {
      ticket_no: '7843022810022',
      date: '2025-02-09',
      amount: '38119.00',
      type: 'trabill',
    },
    {
      ticket_no: '7843022810019',
      date: '2025-02-09',
      amount: '38119.00',
      type: 'trabill',
    },
    {
      ticket_no: '7843022810020',
      date: '2025-02-09',
      amount: '38119.00',
      type: 'trabill',
    },
    {
      ticket_no: '7843022810021',
      date: '2025-02-09',
      amount: '38119.00',
      type: 'trabill',
    },
    {
      ticket_no: '7843022810007',
      date: '2025-02-09',
      amount: '38140.00',
      type: 'trabill',
    },
    {
      ticket_no: '7843022852478',
      date: '2025-02-19',
      amount: '53839.00',
      type: 'trabill',
    },
    {
      date: '2025-02-04',
      ticket_no: '7843022793852',
      amount: '69515.00',
      type: 'bsp',
    },
    {
      date: '2025-02-10',
      ticket_no: '7843022810022',
      amount: '38119.00',
      type: 'bsp',
    },
    {
      date: '2025-02-10',
      ticket_no: '7843022810019',
      amount: '38119.00',
      type: 'bsp',
    },
    {
      date: '2025-02-10',
      ticket_no: '7843022810020',
      amount: '38119.00',
      type: 'bsp',
    },
    {
      date: '2025-02-10',
      ticket_no: '7843022810021',
      amount: '38119.00',
      type: 'bsp',
    },
    {
      date: '2025-02-10',
      ticket_no: '7843022810007',
      amount: '38069.00',
      type: 'bsp',
    },
    {
      date: '2025-02-18',
      ticket_no: '7843022847662',
      amount: '12256.00',
      type: 'bsp',
    },
    {
      date: '2025-02-20',
      ticket_no: '7843022852478',
      amount: '53820.00',
      type: 'bsp',
    },
  ];

  const groupedData = useMemo(() => {
    const ticketGroups: Record<string, any[]> = {};

    rawData.forEach((ticket) => {
      if (!ticketGroups[ticket.ticket_no]) {
        ticketGroups[ticket.ticket_no] = [];
      }
      ticketGroups[ticket.ticket_no].push(ticket);
    });

    const processedData: any[] = [];

    Object.values(ticketGroups).forEach((group) => {
      if (group.length === 1) {
        processedData.push(group[0]);
        return;
      }

      const trabillData = group.filter((ticket) => ticket.type === 'trabill');
      const bspData = group.filter((ticket) => ticket.type === 'bsp');

      if (trabillData.length > 0 && bspData.length > 0) {
        const trabillAmount = parseFloat(trabillData[0].amount);
        const bspAmount = parseFloat(bspData[0].amount);
        const amountMatch = trabillAmount === bspAmount;
        const difference = (trabillAmount - bspAmount).toFixed(2);

        trabillData.forEach((ticket) => {
          processedData.push({
            ...ticket,
            rowSpan: group.length,
            amountMatch,
            difference: amountMatch ? (
              <Typography.Text>{'✅'}</Typography.Text>
            ) : (
              <strong style={{ color: 'red' }}>{`${difference}`} ❌</strong>
            ),
          });
        });

        // BSP টিকেটের জন্য প্রক্রিয়া
        bspData.forEach((ticket) => {
          processedData.push({
            ...ticket,
            rowSpan: 0,
            amountMatch,
            difference: amountMatch ? (
              <Typography.Text>{'✅'}</Typography.Text>
            ) : (
              <strong style={{ color: 'red' }}>{`${difference}`} ❌</strong>
            ),
          });
        });
      }
    });

    return processedData;
  }, [rawData]);

  const columns: ColumnsType<any> = [
    {
      title: 'Ticket No',
      dataIndex: 'ticket_no',
      key: 'ticket_no',
      align: 'start',
      onCell: (record) => ({
        rowSpan: record?.rowSpan,
      }),
    },
    {
      title: 'Issue Date',
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: 'Amount',
      dataIndex: 'amount',
      key: 'amount',
      align: 'right',
    },
    {
      title: 'Difference',
      dataIndex: 'difference',
      key: 'difference',
      align: 'center',
      render: (value, record) => {
        return <Typography.Text>{value}</Typography.Text>;
      },
      onCell: (record) => ({
        rowSpan: record?.rowSpan,
      }),
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      render: (curr) => {
        if (curr === 'bsp')
          return (
            <Tag color='blue' style={{ width: 60, textAlign: 'center' }}>
              BSP
            </Tag>
          );
        if (curr === 'trabill')
          return (
            <Tag color='#007bff' style={{ width: 60, textAlign: 'center' }}>
              TRABILL
            </Tag>
          );
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={groupedData}
      size='small'
      bordered
      pagination={false}
      rowClassName={(record) => (record.rowSpan ? 'parent-row' : 'child-row')}
    />
  );
};

export default TicketTable;
